import "@babel/polyfill";
import $ from 'jquery';
import form from "./__modules/form";
import loader from './__modules/loader';
import slider from './__modules/slider';
import service from './__modules/service';

document.addEventListener('DOMContentLoaded', () => {
    // Main Init Loader
	if($(".main").length) {
		loader();
	}

	// Slider Init
	if($(".slider").length) {
		slider();
	}

	// Menubar click
	$(".menubar").on("click", (e) => {
		e.preventDefault();

		$(".menubar").toggleClass("active");
		$(".header").toggleClass("header--black");
		$(".menu").slideToggle();
	});

	if($(".form-control").length) {
		form();
	}

	if($(".service--main").length) {
		service();
	}
});

window.addEventListener('load', () => {
	// Calculate Sub Menu Bg
	calculateSubMenuBg();
});

window.addEventListener('resize', () => {
	// On resize remove style attributes
	if($(window).width() > 991) {
		$(".menu").removeAttr("style");
		calculateSubMenuBg();
	}
});

window.addEventListener('scroll', () => {
});

function calculateSubMenuBg() {
	var headerHeight = $(".header").outerHeight(),
		menuItemHeight = $(".menu li").height(),
		subMenu = $(".menu > li > ul"),
		subMenuHeight = subMenu.outerHeight(),
		distance = (headerHeight / 2) + (menuItemHeight / 2),
		subMenuCalcHeight = subMenuHeight - distance;

	document.documentElement.style.setProperty('--menu-sub-after', subMenuCalcHeight + "px");
}